const canvas = document.getElementById('custom-crop-canvas');
const image = canvas.getAttribute('data-image');
const modal = document.querySelector('.js-custom-modal');
const modalInner = modal.querySelector('.custom-modal__inner');
const closeBtn = document.querySelectorAll('.js-custom-modal__close');
const cropBtnModal = document.querySelector('.js-add-to-cart');
const customWidth = document.querySelectorAll('.js-custom-width')
const customHeight = document.querySelectorAll('.js-custom-height');
const accordionHead = document.querySelectorAll('.js-product-option-box-head');
const sidebar = document.querySelector('.product-option-form');
const modalOverlay = document.querySelector('.js-custom-modal__overlay');
const qty = document.querySelectorAll('.js-qty__num');
const productForm = document.querySelector('.product-single__form');
const modalAddToCart = document.querySelector('.js-custom-add-to-cart');
const radios = document.querySelectorAll('.js-option-box');
const priceTarget = document.querySelectorAll('.js-price-target');


const className = 'is-open';
let percentage = window.innerWidth < 768 ? .9 : 0.6; // 60% of the container width
const modalWidth = 1440;
let width = 0;
let height = 0;
let holeWidth = width;
let holeHeight = height;
let selectedVariant = null;
const imageOffset = 20;
let widthWithOffset = width + imageOffset;
let heightWithOffset = height + imageOffset;
const MIN_CM = 100;
const borderWidth = 1;

const state = {
	width: null,
	height: null,
	selectedVariantValue: 46,
	option: 1,
	optionValue: 'Intissé', 
	price: 46
};

const toggleElements = [...closeBtn, modalOverlay];
const modalInputs = [customWidth, customHeight];

const layers = {
	stage: null,
	maskLayer: null,
	transparentHole: null,
	borderRect: null,
	mask: null,
	image: null,
	group: null,
	textWidth: null,
	textHeight: null,
}

function initKonva() {
	return new Promise((resolve) => {
		const imageObj = new Image();
		imageObj.src = image;

		imageObj.onload = function () {
			resolve();
			width = imageObj.width;
			height = imageObj.height;
			widthWithOffset = width + imageOffset;
			heightWithOffset = height + imageOffset;
			holeWidth = width;
			holeHeight = height;

			layers.stage = new Konva.Stage({
				container: canvas,
				width: imageObj.width + imageOffset,
				height: imageObj.height + imageOffset,
			});
		
			const layer = new Konva.Layer();
			layers.stage.add(layer);

			layers.image = new Konva.Image({
				image: imageObj,
				x: imageOffset,
				y: imageOffset,
				width: width,
				height: height,
			});
			layer.add(layers.image);

			layers.mask = new Konva.Rect({
				x: imageOffset,
				y: imageOffset,
				width: width,
				height: height,
				fill: 'white',
				opacity: 0.8,
			});
			layers.maskLayer = new Konva.Layer();
			layers.maskLayer.add(layers.mask);

			layers.group = new Konva.Group({
				x: imageOffset,
				y: imageOffset,
				draggable: true,
				dragBoundFunc: function (pos) {
					return customDragBoundFunc(pos);
				},
			});

			layers.transparentHole = new Konva.Rect({
				x: 0,
				y: 0,
				width: holeWidth,
				height: holeHeight,
				fill: 'black',
				globalCompositeOperation: 'destination-out',
			});

			layers.borderRect = new Konva.Rect({
				x: -borderWidth,
				y: -borderWidth,
				width: holeWidth + borderWidth*2,
				height: holeHeight + borderWidth*2,
				stroke: '#111',
				strokeWidth: borderWidth,
				listening: false,
			});

			layers.textWidth = new Konva.Text({
				x: holeWidth / 2,
				y: -15,
				fontSize: 12,
				fontFamily: 'Times',
				fill: 'black',
				align: 'center',
				opacity: 0.5,
			});

			layers.textHeight = new Konva.Text({
				x: -15,
				y: holeHeight / 2,
				fontSize: 12,
				fontFamily: 'Times',
				fill: 'black',
				rotation: -90,
				opacity: 0.5,
			});
			layers.textHeight.offsetX(layers.textHeight.height());
			
			layers.group.add(layers.transparentHole);
			layers.group.add(layers.borderRect);
			layers.group.add(layers.textWidth);
			layers.group.add(layers.textHeight);

			layers.maskLayer.add(layers.group);
			layers.stage.add(layers.maskLayer);

			layer.draw();
			layers.maskLayer.draw();
		};
	})
}

function calculateScale() {
	const previewWrapper = document.querySelector('.custom-modal__preview');
	return previewWrapper.offsetWidth / widthWithOffset;
}

function updateGroupSizes() {
	const size = fitBox(state.width, state.height);
	holeWidth = size.width || MIN_CM;
	holeHeight = size.height || MIN_CM;
	
	const [transparentHole, borderRect, text1, text2] = layers.group.getChildren();
	layers.group.x((widthWithOffset) / 2 - size.width / 2);
	layers.group.y((heightWithOffset) / 2 - size.height / 2);

	transparentHole.width(size.width + imageOffset);
	transparentHole.height(size.height + imageOffset);

	borderRect.width(size.width + imageOffset + borderWidth*2);
	borderRect.height(size.height + imageOffset + borderWidth*2);
	
	text1.x(size.width / 2 - layers.textWidth.width() / 2);
	text1.y(-15);
	text2.x(-15);
	text2.y(size.height / 2 + layers.textWidth.height() / 2);
	text1.text(`${state.width || 0} cm`);
	text2.text(`${state.height || 0} cm`);
}

function customDragBoundFunc(pos, scale = 1) {
	const maxX = (width - holeWidth) * scale;
	const maxY = (height - holeHeight) * scale;
	const minX = imageOffset * scale;
	const minY = imageOffset * scale;
	
	const newX = Math.max(minX, Math.min(pos.x, maxX));
	const newY = Math.max(minY, Math.min(pos.y, maxY));

	return {
		x: newX,
		y: newY,
	}
}

function fitStageIntoParentContainer() {
	percentage = window.innerWidth < 768 ? .85 : 0.6;
	const scale = calculateScale();
	const scaledWidth = widthWithOffset * scale;
	const scaledHeight = heightWithOffset * scale;
	layers.stage.width(scaledWidth);
	layers.stage.height(scaledHeight);
	layers.stage.scale({ x: scale, y: scale });
	
	if (layers.group) {
		layers.group.dragBoundFunc(function (pos) {
			return customDragBoundFunc(pos, scale);
		});
	}
}

function fitBox(contentWidth, contentHeight) {
  const scale = Math.min((width - imageOffset) / contentWidth, (height - imageOffset) / contentHeight);
  const fittedWidth = contentWidth * scale;
  const fittedHeight = contentHeight * scale;
  
  return {
    width: fittedWidth,
    height: fittedHeight,
    scale: scale
  };
}

function calculateCost(baseCost, userWidth, userHeight) {
	const baseWidth = MIN_CM; 
	const baseHeight = MIN_CM;
	const baseArea = baseWidth * baseHeight;
	const userArea = (userWidth || baseWidth) * (userHeight || baseHeight);
	const costPerSqCm = baseCost / baseArea;
	return userArea * costPerSqCm;
}

function updatePrice() {
	const baseCost = state.selectedVariantValue;
	const width = parseFloat(state.width) < MIN_CM ? MIN_CM : parseFloat(state.width); 
	const height = parseFloat(state.height) < MIN_CM ? MIN_CM : parseFloat(state.height); 
	const totalCost = calculateCost(baseCost, width, height);
	state.price = totalCost;
	priceTarget.forEach((el) => el.textContent = totalCost.toFixed(2).replace('.', ','));
}

// Responsive canvas
window.addEventListener('resize', fitStageIntoParentContainer);

// Accordion logic
accordionHead.forEach((head) => {
	head.addEventListener('click', (e) => {
		const parent = head.parentNode;
		parent.classList.toggle('is-active');
	});
})

// Close modal logic
toggleElements.forEach(el => el.addEventListener('click', () => modal.classList.remove(className)));
document.addEventListener('keydown', (e) => {
	if (e.key === 'Escape' && modal.classList.contains(className)) {
		modal.classList.remove(className);
	}
});

// Open modal logic
cropBtnModal.addEventListener('click', async (e) => {
	await initKonva();
	modal.classList.add(className);
	updateGroupSizes();
	fitStageIntoParentContainer();
});

const inputsTarget = document.querySelectorAll('.js-custom-width, .js-custom-height');
inputsTarget.forEach((input) => {
	input.addEventListener('keyup', (el) => {
		const target = el.target;
		const value = target.value;
		state[target.name] = parseFloat(value);
		
		inputsTarget.forEach((sub) => {
			if ((sub != target) && (sub.name == target.name)) {
				sub.value = value;
			}
		})

		updatePrice();
		updateGroupSizes();
	})
})


radios.forEach((radio) => {
	radio.addEventListener('change', (e) => {
		if (!e.isTrusted) return;

		const target = e.target;
		state.selectedVariantValue = parseFloat(target.value.replace(',', '.'));
		state.option = target.dataset.option;
		state.optionValue = target.dataset.value;
		console.log(state)
		updatePrice();

		radios.forEach((el) => {
			if (el !== target && el.value == target.value) {
				el.checked = true;
			}
		});
	});
});

document.querySelectorAll('.js-qty__adjust').forEach((el) => {
	el.addEventListener('click', (e) => {
		e.preventDefault();
		const input = e.target.closest('.js-qty__wrapper').querySelector('.js-qty__num');
		if (!input || !e.isTrusted) return;

		let value = parseInt(input.value);
		qty.forEach((sub) => {
			if (sub !== input) {
				sub.value = value;
			}	
		})
	});
})

qty.forEach((el) => {
	el.addEventListener('change', (e) => {
		if (!e.isTrusted) return;

		const value = e.target.value;
		if (parseInt(value) < 1) {
			return;
		}
		qty.forEach((sub) => {
			if (sub !== e.target) {
				console.log(1)
				sub.value = value;
			}	
		})
	});
});


modalAddToCart.addEventListener('click', (e) => {
	e.preventDefault();
	if(!state.width || !state.height) {
		alert('Veuillez entrer une largeur et une hauteur valides.');
		return;
	}

	modalAddToCart.disabled = true;
	
	// Calculate the actual offset relative to the image (excluding imageOffset and accounting for scale)
	const actualOffsetX = parseInt((layers.group.x()) - imageOffset);
	const actualOffsetY = parseInt((layers.group.y()) - imageOffset);
	const boxSize = `${layers.transparentHole.width()}x${layers.transparentHole.height()}`;
	productForm.insertAdjacentHTML(
		'beforeend', 
		`
		<input type="hidden" name="properties[type]" value="${state.optionValue}">
		<input type="hidden" name="properties[Longueur]" value="${state.width}">
		<input type="hidden" name="properties[Hauteur]" value="${state.height}">
		<input type="hidden" name="properties[__option]" value="${state.option}">
		<input type="hidden" name="properties[__box-size]" value="${boxSize}">
		<input type="hidden" name="properties[__offset-x]" value="${actualOffsetX < 0 ? 0 : actualOffsetX}">
		<input type="hidden" name="properties[__offset-y]" value="${actualOffsetY < 0 ? 0 : actualOffsetY}">
		<input type="hidden" name="properties[__price]" value="${(parseFloat(state.price)*100).toFixed(0)}">
		`
	);
	productForm.querySelector('.product-single__form .add-to-cart').click();
})
